import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { SearchIcon } from "../shared-components/icons";
import Input from "../shared-components/Input";

export type SearchBarProps = {
  placeholder?: string;
};

export default function SearchBar({ placeholder }: SearchBarProps) {
  const [params, setParams] = useSearchParams();
  const [search, setSearch] = useState(params.get("search") || "");
  const [page] = useState(params.get("page") || "");

  const updateSearchParams = () => {
    page !== "" ? setParams({ search, page }) : setParams({ search });
  };

  const handler = (e: React.SyntheticEvent): void => {
    e.preventDefault();
    updateSearchParams();
  };

  useEffect(() => {
    if (!params.get("search")) {
      setSearch("");
    }
  }, [params]);

  return (
    <div>
      <form onSubmit={handler}>
        <div className="top-0 z-10 flex items-center px-4">
          <div className="relative">
            <Input
              role="search"
              type="text"
              placeholder={placeholder ?? "Search by Name or Company"}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <div className="absolute top-3 right-3">
              <SearchIcon
                className="z-20 hover:text-gray-500 h-5 w-5 text-gray-500 cursor-pointer"
                onClick={updateSearchParams}
              ></SearchIcon>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}
